// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Signup_signup__tKNhQ {
  background-color: var(--color-bg-login);
  width: 100vw;
  height: 100vh;
}

.Signup_signupFormContainer__4Ntg5 {
  width: 448px;
  height: 455px;
  background-color: var(--color-bg-login-box);
  margin-left: auto;
  margin-right: auto;
  margin-top: 200px;
  box-shadow: 0px 3px 6px var(--color-theme-cloud);
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 25vh; 
  left: 50vw; 
  transform: translate(-50%, -50%);
}

.Signup_signupFormHeader__0fPYR {
  color: var(--color-font-2);
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 20px;
}

.Signup_signupForm__0MnMi {
  margin: 40px;
}

.Signup_email_container__rVHFi {
  margin-bottom: 10px;
}

.Signup_input_container__YdZ0G {
  width: 100% !important;
  margin-bottom: 5px;
}

.Signup_password_input__8lDnB {
  width: 100% !important;
  margin-top: 20px !important;
}

.Signup_btnContainer__spZGw {
  margin-top: 25px;
  display: flex;
  justify-content: flex-end;
}

.Signup_signupBtn__hgEgJ {
  width: 174px;
  height: 41px;
  border: 1px solid var(--color-theme-blue);
  border-radius: 4px;
  background-color: var(--color-theme-white);
  color: var(--color-theme-blue);
  cursor: pointer;
  font-size: 16px;
}

.Signup_signupBtn__hgEgJ:hover {
  color: var(--color-theme-white);
  background-color: var(--color-theme-blue);
}

.Signup_inputError__c4AEj {
  margin-top: 5px;
  color: var(--color-font-red);
  font-size: 12px;
}

.Signup_signupError__\\+Dk5U {
  padding-top: 6px;
  text-align: center;
  color: var(--color-font-red);
  font-size: 10px;
  font-weight: bold;
}

.Signup_link__NeKC2 {
  color: var(--color-font-10);
  padding: 32px;
  font-size: 16px;
}

.Signup_password_requirements__nPzHP {
  margin-top: 10px;
  font-size: 12px;
}

.Signup_password_requirements_error__8dd94 {
  margin-top: 10px;
  font-size: 12px;
  color: var(--color-theme-red);
}
`, "",{"version":3,"sources":["webpack://./src/@_pages/Signup/Signup.module.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;EACvC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gDAAgD;EAChD,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,SAAS;EACT,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,0CAA0C;EAC1C,8BAA8B;EAC9B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B","sourcesContent":[".signup {\n  background-color: var(--color-bg-login);\n  width: 100vw;\n  height: 100vh;\n}\n\n.signupFormContainer {\n  width: 448px;\n  height: 455px;\n  background-color: var(--color-bg-login-box);\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 200px;\n  box-shadow: 0px 3px 6px var(--color-theme-cloud);\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  top: 25vh; \n  left: 50vw; \n  transform: translate(-50%, -50%);\n}\n\n.signupFormHeader {\n  color: var(--color-font-2);\n  font-weight: bold;\n  font-size: 22px;\n  margin-bottom: 20px;\n}\n\n.signupForm {\n  margin: 40px;\n}\n\n.email_container {\n  margin-bottom: 10px;\n}\n\n.input_container {\n  width: 100% !important;\n  margin-bottom: 5px;\n}\n\n.password_input {\n  width: 100% !important;\n  margin-top: 20px !important;\n}\n\n.btnContainer {\n  margin-top: 25px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.signupBtn {\n  width: 174px;\n  height: 41px;\n  border: 1px solid var(--color-theme-blue);\n  border-radius: 4px;\n  background-color: var(--color-theme-white);\n  color: var(--color-theme-blue);\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.signupBtn:hover {\n  color: var(--color-theme-white);\n  background-color: var(--color-theme-blue);\n}\n\n.inputError {\n  margin-top: 5px;\n  color: var(--color-font-red);\n  font-size: 12px;\n}\n\n.signupError {\n  padding-top: 6px;\n  text-align: center;\n  color: var(--color-font-red);\n  font-size: 10px;\n  font-weight: bold;\n}\n\n.link {\n  color: var(--color-font-10);\n  padding: 32px;\n  font-size: 16px;\n}\n\n.password_requirements {\n  margin-top: 10px;\n  font-size: 12px;\n}\n\n.password_requirements_error {\n  margin-top: 10px;\n  font-size: 12px;\n  color: var(--color-theme-red);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"signup": `Signup_signup__tKNhQ`,
	"signupFormContainer": `Signup_signupFormContainer__4Ntg5`,
	"signupFormHeader": `Signup_signupFormHeader__0fPYR`,
	"signupForm": `Signup_signupForm__0MnMi`,
	"email_container": `Signup_email_container__rVHFi`,
	"input_container": `Signup_input_container__YdZ0G`,
	"password_input": `Signup_password_input__8lDnB`,
	"btnContainer": `Signup_btnContainer__spZGw`,
	"signupBtn": `Signup_signupBtn__hgEgJ`,
	"inputError": `Signup_inputError__c4AEj`,
	"signupError": `Signup_signupError__+Dk5U`,
	"link": `Signup_link__NeKC2`,
	"password_requirements": `Signup_password_requirements__nPzHP`,
	"password_requirements_error": `Signup_password_requirements_error__8dd94`
};
export default ___CSS_LOADER_EXPORT___;
